module.exports = __webpack_public_path__ + "media/images/writer-offering-bg-cd58878eeab56b51459aa3667570a83c.png";